import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor;
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, makeObservable } from "mobx";
import isDefined from "../../Core/isDefined";
export let CompositeOrientation = /*#__PURE__*/function (CompositeOrientation) {
  CompositeOrientation[CompositeOrientation["HORIZONTAL"] = 0] = "HORIZONTAL";
  CompositeOrientation[CompositeOrientation["VERTICAL"] = 1] = "VERTICAL";
  return CompositeOrientation;
}({});
export let CompositeBarModel = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _class = class CompositeBarModel {
  constructor(items, options) {
    _initializerDefineProperty(this, "_items", _descriptor, this);
    _defineProperty(this, "options", void 0);
    makeObservable(this);
    if (options) {
      this.options = options;
    }
    if (items) {
      this.setItems(items);
    }
  }
  get items() {
    return this._items;
  }
  get visibleItems() {
    return this.items.filter(item => item.controller.visible);
  }
  get pinnedItems() {
    return this.items.filter(item => item.controller.visible && item.controller.pinned);
  }
  setItems(items) {
    const result = [];
    if (!this.items || this.items.length === 0) {
      this._items = items.map(item => {
        return this.createCompositeBarItem(item);
      });
    } else {
      const existingItems = this.items;
      for (const newItem of items) {
        const existingItem = existingItems.filter(_ref => {
          let {
            id
          } = _ref;
          return id === newItem.id;
        })[0];
        if (existingItem) {
          existingItem.controller = newItem.controller;
          existingItem.name = newItem.name;
          existingItem.title = newItem.title;
          existingItem.screenSize = newItem.screenSize;
          result.push(existingItem);
        } else {
          result.push(this.createCompositeBarItem(newItem));
        }
      }
      this._items = result;
    }
  }
  add(newItem, requestedIndex) {
    const existingItem = this.findItem(newItem.id);
    if (existingItem) {
      existingItem.name = newItem.name;
      existingItem.controller = newItem.controller;
      existingItem.title = newItem.title;
      existingItem.screenSize = newItem.screenSize;
      existingItem.order = newItem.order;
    } else {
      const item = this.createCompositeBarItem(newItem);
      if (isDefined(requestedIndex)) {
        let index = 0;
        let rIndex = requestedIndex;
        while (rIndex > 0 && index < this.items.length) {
          if (this.items[index++].controller.visible) {
            rIndex--;
          }
        }
        this.items.splice(index, 0, item);
      } else if (!isDefined(item.order)) {
        this.items.push(item);
      } else {
        let index = 0;
        while (index < this.items.length && typeof this.items[index].order === "number" && this.items[index].order < item.order) {
          index++;
        }
        this.items.splice(index, 0, item);
      }
    }
  }
  remove(id) {
    for (let index = 0; index < this.items.length; index++) {
      if (this.items[index].id === id) {
        this.items.splice(index, 1);
        return;
      }
    }
  }
  hide(id) {
    for (const item of this.items) {
      if (item.id === id) {
        if (item.controller.visible) {
          item.controller.setVisible(false);
          return;
        }
        return;
      }
    }
  }
  show(id) {
    for (const item of this.items) {
      if (item.id === id) {
        if (!item.controller.visible) {
          item.controller.setVisible(true);
          return;
        }
        return;
      }
    }
  }
  disable(id) {
    for (const item of this.items) {
      if (item.id === id) {
        if (!item.controller.disabled) {
          item.controller.disabled = true;
          return;
        }
        return;
      }
    }
  }
  enable(id) {
    for (const item of this.items) {
      if (item.id === id) {
        if (item.controller.disabled) {
          item.controller.disabled = false;
          return;
        }
        return;
      }
    }
  }
  move(compositeId, toCompositeId) {
    const fromIndex = this.findIndex(compositeId);
    const toIndex = this.findIndex(toCompositeId);

    // Make sure both items are known to the model
    if (fromIndex === -1 || toIndex === -1) {
      return;
    }
    const sourceItem = this.items.splice(fromIndex, 1)[0];
    this.items.splice(toIndex, 0, sourceItem);
  }
  setPinned(id, pinned) {
    for (const item of this.items) {
      if (item.id === id) {
        if (item.controller.pinned !== pinned) {
          item.controller.pinned = pinned;
          return;
        }
        return;
      }
    }
  }
  setCollapsed(id, collapsed) {
    const item = this.findItem(id);
    if (item) {
      item.controller.collapsed = collapsed;
    }
  }
  findItem(id) {
    return this.items.filter(item => item.id === id)[0];
  }
  createCompositeBarItem(item) {
    return item;
  }
  findIndex(id) {
    for (let index = 0; index < this.items.length; index++) {
      if (this.items[index].id === id) {
        return index;
      }
    }
    return -1;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_items", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "items", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "items"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visibleItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "remove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hide", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "show", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "disable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enable", [action], Object.getOwnPropertyDescriptor(_class.prototype, "enable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "move", [action], Object.getOwnPropertyDescriptor(_class.prototype, "move"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPinned", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPinned"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCollapsed", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "setCollapsed"), _class.prototype), _class);